export const profileTextBox = [
  "firstname",
  "lastname",
  "phNum",
  "portalLanguageId",
  "timezonename",
  "addressline1",
  "phCity",
  "phState",
  "phZipcode",
  "countryId",
  "languageId",
  "parentCustomerId"
];

export const saveContact = [
  "firstNamesavedContacts",
  "lastNamesavedContacts",
  "phNumsavedContacts",
  "emailsavedContacts",
  "countryNamesavedContacts",
  "selectedaccountid"
];

export const addministrator = [
  "firstNamesavedContacts",
  "lastNamesavedContacts",
  "phNumsavedContacts",
  "emailsavedContacts",
  "selectedaccountid",
];
export const saveAddress = [
  "address1_line1",
  "address1_city",
  "address1_stateorprovince",
  "address1_postalcode",
  "countryNameid",
];
